<!--名单公示-->
<template>
  <div>
    <div>
      <top-item-com active="4" :ssid="ssid"></top-item-com>
    </div>
    <div>
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        :disabled="!isAtTop"
      >
        <van-collapse v-model="activeNames" accordion>
          <van-collapse-item
            :name="item.XMID"
            v-for="(item, index) in resultList"
            :key="index"
            @click.native="getMdDataHandler(item)"
          >
            <template #title>
              <div>
                <van-tag type="success" v-if="item.ISGSCQ === '1'"
                  >已公示</van-tag
                >
                <van-tag type="danger" v-if="item.ISGSCQ !== '1'"
                  >未公示</van-tag
                >
                {{ item.XMQC }}
              </div>
            </template>
            <div>
              <div style="color:black">
                <table class="tableClass">
                  <tr>
                    <td v-if="SZZL === 'XH'">
                      组号
                    </td>
                    <td>
                      位置号
                    </td>
                    <td
                      v-if="
                        rydList.length > 0 &&
                          rydList[0].SSLX.substr(1, 2) !== 'T'
                      "
                    >
                      人/队名
                    </td>
                    <td>
                      队伍全称
                    </td>
                    <td>
                      队伍简称
                    </td>
                  </tr>
                  <tr v-for="(ryItem, ryIndex) in rydList" :key="ryIndex">
                    <td v-if="SZZL === 'XH'">{{ ryItem.ZSORLUNSHU }}组</td>
                    <td>
                      {{ ryItem.WZH }}
                    </td>
                    <td v-if="ryItem.SSLX.substr(1, 2) !== 'T'">
                      {{
                        ryItem.RYXM +
                          (ryItem.TEAMRYXM_FIN &&
                          ryItem.TEAMRYXM_FIN.length > 0 &&
                          ryItem.TEAMRYXM_FIN !== "-"
                            ? "/" + ryItem.TEAMRYXM_FIN
                            : "")
                      }}
                    </td>
                    <td>
                      {{ ryItem.DWQC }}
                    </td>
                    <td>
                      {{ ryItem.DWJC }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>
      </van-pull-refresh>
    </div>
    <div style="height:100px;width:15px;"></div>
    <loading-com />
  </div>
</template>

<script>
import HeaderCom from "./../commonCom/HeaderCom.vue";
import LoadingCom from "../commonCom/LoadingCom.vue";
import TopItemCom from "../commonCom/TopItemCom.vue";
export default {
  components: { HeaderCom, LoadingCom, TopItemCom },
  name: "CqGsIndex",
  data() {
    return {
      isLoading: false,
      SZZL: "XH",
      activeNames: [],
      ssid: "",
      resultList: [],
      rydList: [],
      routeValue: "",
      isAtTop: true // 是否在顶部
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    this.mainLoadData();
    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 处理滚动事件
    handleScroll() {
      // 判断是否在顶部（允许10px的误差）
      this.isAtTop =
        window.pageYOffset <= 10 || document.documentElement.scrollTop <= 10;
    },
    onRefresh() {
      this.mainLoadData();
    },
    onTopClickLeft() {
      this.$router.push({ path: "/xmIndex", query: { ssid: this.ssid } });
    },
    mainLoadData() {
      var busData = {};
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "getAllXmData" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        this.isLoading = false;
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.resultList = data.content;
      });
    },
    getMdDataHandler(item) {
      this.rydList = [];
      if (item.ISGSCQ !== "1") {
        alert("抽签结果未公示");
        return;
      }
      var busData = {
        xmid: item.XMID
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "getCqmdData" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        // console.log(data);
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.rydList = data.content;
        if (this.rydList.length > 0) {
          this.SZZL = this.rydList[0].SZZL;
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.van-field {
  padding: 3px;
  border-radius: 5px;
}
.dropClass {
  background: #ffffff4f;
  padding: 8px;
  border-radius: 5px;
  font-size: 13px;
  color: #fff;
}
.van-overlay {
  background-color: rgba(0, 0, 0, 0.5);
}
.itemContentMain {
  background: #fff;
  margin: 10px;
  padding: 10px;
  border-radius: 5px;
  position: relative;
}
.van-image--round {
  margin-top: 15px;
}
.van-tag {
  font-size: 13px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 3px;
  padding-bottom: 3px;
}
.textMainDiv {
  padding-top: 15px;
}
/deep/.van-nav-bar {
  position: fixed;
  top: 0px;
  width: 100%;
}
.tableClass {
  background: #fff;
  width: 100%;
  border-collapse: collapse;
}
.tableClass td {
  width: 100px;
  text-align: center;
  border: 1px solid #ddd;
  padding: 10px;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/RyGsIndex/CqGsIndex.vue